import { useState as h, useCallback as u, useEffect as F } from "react";
import { Toast as I } from "../../../components/Toast/Toast.js";
import "@radix-ui/react-toast";
import { jsx as U, Fragment as W } from "theme-ui/jsx-runtime";
import "../../../components/Toast/ToastViewport/ToastViewport.js";
import { useRefs as j, usePointerDownOutside as B, useWillUnmount as R, useIsomorphicLayoutEffect as Y } from "@material-bank/ds-utils";
import { transformHoverToast as _, transformToast as q, toast as z, piledToast as A } from "./styles.js";
import "../../stores/dialogsControllerStore.js";
import "@tanstack/react-query";
import "zustand";
import "zustand/middleware";
import { useToastsStore as p } from "../../stores/toastsStore.js";
import { createElement as G } from "theme-ui";
const te = (E) => {
  const {
    toastViewportRef: m,
    clearToastsOnUnmount: L,
    expanded: n
  } = E, t = p.use.toasts(), O = p.use.deleteToast(), C = p.use.clearToasts(), [l, a] = h(!1), [b, v] = h(t), [f] = j(), e = m == null ? void 0 : m.current, k = u(() => {
    a(!1);
  }, []);
  B({
    ref: m,
    onPointerDownOutside: k
  }), R(() => {
    L && C();
  });
  const y = (s) => setTimeout(() => O(s), 500), r = u(() => {
    a(!0);
  }, []), c = u((s) => {
    s.relatedTarget && !(e != null && e.contains(s.relatedTarget)) && a(!1);
  }, [e]);
  F(() => {
    if (!n)
      return e == null || e.addEventListener("pointerenter", r), e == null || e.addEventListener("pointerleave", c), e == null || e.addEventListener("focusin", r), e == null || e.addEventListener("focusout", c), () => {
        e == null || e.removeEventListener("pointerenter", r), e == null || e.removeEventListener("pointerleave", c), e == null || e.removeEventListener("focusin", r), e == null || e.removeEventListener("focusout", c);
      };
  }, [n, c, r, e]);
  const i = u(() => {
    const s = [];
    let o = [];
    if (t.length <= 1 || n)
      return v(t);
    t.forEach((d, g) => {
      const T = f(d.id).current, H = (T == null ? void 0 : T.clientHeight) ?? 0;
      s.push(H);
      const P = s.slice(0, g).reduce((S, D) => S += D, 0);
      o.push({
        ...d,
        sx: {
          ...l && {
            transform: _(g, P)
          }
        }
      });
    }), v(o);
  }, [f, l, t, n]);
  Y(() => {
    i();
  }, [i, t]);
  const x = u(() => {
    setTimeout(() => i(), 300);
  }, [i]);
  return /* @__PURE__ */ U(W, {
    children: b.map((s, o) => /* @__PURE__ */ G(I, {
      ...s,
      type: "background",
      ref: f(s.id),
      onOpenChange: (d) => y(s.id),
      key: s.id,
      onToggleCollapsible: x,
      sx: {
        ...!n && o > 0 && {
          transform: q(o)
        },
        ...!l && o > 2 && {
          display: "none"
        },
        ...z,
        ...!n && A,
        ...s.sx
      }
    }))
  });
};
export {
  te as ToastsStack
};
